import { type FC, type ReactNode, useCallback, useMemo, useState } from "react";

import { EntityHistoryModal, type EntityHistoryModalProps } from "@/components/modals";

import { EntityHistoryContext, type ShowHistoryParams } from "./entity-history.context";

interface EntityHistoryProviderProps {
	readonly children: ReactNode;
}

export const EntityHistoryProvider: FC<EntityHistoryProviderProps> = ({ children }) => {
	const [entityHistoryModalProps, setEntityHistoryModalProps] = useState<Omit<EntityHistoryModalProps, "onClose">>({});

	const showHistory = useCallback(
		<T extends Record<string, unknown> = Record<string, unknown>>({
			entityType,
			entityId,
			...args
		}: ShowHistoryParams<T>) => {
			setEntityHistoryModalProps({
				...args,
				entityHistoryUrl: `${entityType}/${entityId}`,
			} as Omit<EntityHistoryModalProps, "onClose">);
		},
		[],
	);

	const onCloseModal = useCallback(() => {
		setEntityHistoryModalProps({});
	}, []);

	const value = useMemo(() => {
		return { showHistory, closeHistory: onCloseModal };
	}, [onCloseModal, showHistory]);

	return (
		<EntityHistoryContext.Provider value={value}>
			{children}

			<EntityHistoryModal {...entityHistoryModalProps} onClose={onCloseModal} />
		</EntityHistoryContext.Provider>
	);
};
